import { Switch, SwitchProps } from "@mui/material";
import colors from "../../Constants/colors";
import { useWorkspaceColors } from "../../Contexts/WorkspaceColorContext";

interface ComoSwitchProps extends SwitchProps {}

export function ComoSwitch({ ...props }: ComoSwitchProps) {
  const { colors: workspace } = useWorkspaceColors();

  return (
    <Switch
      disableRipple
      {...props}
      sx={{
        "& .MuiSwitch-thumb": {
          bgcolor: workspace.accent,
          border: `2px solid ${colors.gray500}`,
          boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
        },
        "& .MuiSwitch-track": {
          bgcolor: colors.gray200,
          opacity: 1,
        },
        "& .MuiSwitch-switchBase.Mui-checked": {
          color: colors.gray400,
        },
        "& .MuiSwitch-switchBase.Mui-checked .MuiSwitch-thumb": {
          bgcolor: workspace.accent,
        },
        "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
          bgcolor: colors.gray400,
          opacity: 1,
        },
        ...props.sx,
      }}
    />
  );
}
